import React, { useEffect, useState } from 'react'
import { Col } from 'react-bootstrap'

export default function FormSubmissionHandler({ children, handleSubmit, editing, error, BTNLabel = "Save", IsBTNClicked=false }) {
  console.log("editing: ", editing)
  return (
    <form className='row g-1' onSubmit={handleSubmit}>
      {children}
      <hr />
      <br />
      <br />
      <div class="col-12 text-center FormSubmissionButtonContainer">
        <button type="button" class="btn btn-primary me-sm-3 me-1" onClick={handleSubmit}>{IsBTNClicked ? <> <i class="fas fa-circle-notch fa-spin"></i> &nbsp; &nbsp; </> : <></>}{editing ? 'Update' : BTNLabel}</button>
        <button type="reset" class="btn btn-label-secondary" data-bs-dismiss="modal" aria-label="Close">Cancel</button>
        {error && (<p style={{ color: error.status === 0 ? 'red' : 'green' }}>{error.msg}</p>)}
      </div>
    </form>
  )
}
